// Styles
import './products-slider.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductCarousel = context => {
  const productCarousel = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');

  if (!productCarousel) return;

  const sliderContainer = productCarousel.querySelector('.swiper');
  if (!sliderContainer) return;

  const sliderNumber = sliderContainer.dataset.slideNumber;

  switch (sliderNumber){
    case 'M':
      var sliderNumber360 = 1.6;
      var sliderNumber768 = 3;
      var sliderNumber1920 = 4.1;
      break
    case 'S':
      var sliderNumber360 = 1.6;
      var sliderNumber768 = 3;
      var sliderNumber1920 = 3.1;
      break
    default:
      var sliderNumber360 = 2.4;
      var sliderNumber768 = 3.7;
      var sliderNumber1920 = 5.1;
  }

  const swiper = new Swiper(sliderContainer, {
    slidesPerView: sliderNumber360,
    spaceBetween: 18,
    breakpoints: {
      450: {
        slidesPerView: sliderNumber768,
        spaceBetween: 18
      },
      768: {
        slidesPerView: sliderNumber1920,
        spaceBetween: 16
      }
    },
    navigation: {
      nextEl: productCarousel.querySelector('.swiper-button-next'),
      prevEl: productCarousel.querySelector('.swiper-button-prev'),
    },
    scrollbar: {
      el: productCarousel.querySelector('.swiper-scrollbar'),
      draggable: true
    }
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.products-slider__container'), (el) => {
    window.dAgency.initProductCarousel(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.products-slider__container'), (el) => {
      window.dAgency.initProductCarousel(el);
    });
  });
}
const recommendedActive = document.querySelector(".products-slider__container").dataset.recommended;
if (recommendedActive) {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.products-slider__container');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          Array.from(document.querySelectorAll('.products-slider__container'))
          .map(el => window.dAgency.initProductCarousel(el));

          if (typeof (window.dAgency.initProductTile) !== 'undefined') {
            const productTiles = productRecommendationsSection.querySelectorAll('.product-tile__container');
            if (productTiles.length > 0) {
              productTiles.forEach(tile => {
                window.dAgency.initProductTile(tile);
              });
            }
          }

          $(function() {
            $('[data-link-proxy]').ProxyLink({
              excludes: ['.slick-dots', '.product-tile__variants', '.swym-add-to-wishlist-view-product', '.product-tile__hover--quick-buy--button', '.product-tile__hover--quick-buy__form__option__values']
            });
          });
        }

      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.products-slider__container');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);
}
